import styled from "styled-components";

/** 共通コンポーネント編集 UI 内で、componentId 行の下にぶら下げる表示条件編集ブロック */
export const ConditionsBlock = styled.div`
  margin: 4px 0 8px 24px;
  padding: 6px 10px;
  border-left: 2px solid #c7d2fe;
  background: #f8fafc;
  border-radius: 4px;
`;

/** 表示条件ブロックの見出し */
export const ConditionsBlockLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 4px;
`;

/** 表示モードで条件一覧を箇条書きするコンテナ */
export const ConditionsReadOnlyList = styled.div`
  margin: 4px 0 0 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

/** 表示モードでの 1 条件行（先頭に中黒を付ける） */
export const ConditionsReadOnlyItem = styled.div`
  font-size: 0.8rem;
  color: #475569;
  &::before {
    content: "・";
    margin-right: 2px;
  }
`;
